'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import * as T from 'prop-types';
import React from 'react';
import {Button} from '../../../components/buttons/Button';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {PLACEHOLDER_MILESTONE} from '../../../projects/domain/MilestoneDomain';
import {isTaskType, TaskType} from '../../enums/TaskType';


export function MilestoneItemView(props) {
  const model = props.model;
  const isPlaceholder = getId(model) === PLACEHOLDER_MILESTONE.id;
  const name = isPlaceholder ? props.placeholderName : model.name;
  const taskCount = get(model, 'metrics.taskCount');
  let description;

  if (isPlaceholder) {
    description = props.placeholderDescription;
  } else {
    description = model.description ? model.description : props.descriptionNullMessage;
  }

  // TODO: replace legacy classes with custom styling for this component under current style guide
  return (
    <div className={classNames("MilestoneItem", props.className, model.isCollapsed ? '' : 'MilestoneItem__active')}>
      <Button
        className="MilestoneItem__visibilityButton"
        title={model.isCollapsed ? props.iconShowTitle : props.iconHideTitle}
        label={model.isCollapsed ? '+' : '—'}
        bindParam={model}
        onClick={props.onClickVisibilityButton}
      />
      <span
        className="MilestoneItem__name"
        title={description}
      >
        {name}

        {model.isCollapsed ? (
          <span>
            {`  (${isNumber(taskCount) ? taskCount : 0})`}
          </span>
        ) : null}
      </span>
      {props.canAddTask ? (
        <Button
          className={classNames(
            "MilestoneItem__outlinedButton",
            {MilestoneItem__outlinedButton_hidden: model.isCollapsed})}
          label={props.addTaskLabel}
          bindParam={model}
          onClick={props.onAddTask}
        />
      ) : null}
      {props.taskType !== TaskType.TEMPLATE && props.canDownloadFiles && props.supportsDownload ? (
        <Button
          className={classNames(
            "MilestoneItem__outlinedButton MilestoneItem__downloadButton",
            {MilestoneItem__outlinedButton_hidden: model.isCollapsed})}
          label={props.downloadTitle}
          bindParam={model}
          onClick={props.onDownloadAllFiles}
        />
      ) : null}
      <Button
        className="MilestoneItem__optionsButton"
        title={props.iconOptionsTitle}
        bindParam={model}
        onClick={props.onClickOptionsButton}
        iconClass="context-icon"
      />
    </div>
  );
}

MilestoneItemView.propTypes = {
  taskType: isTaskType.isRequired,
  model: T.object.isRequired,
  canAddTask: T.bool.isRequired,
  supportsDownload: T.bool.isRequired,
  canDownloadFiles: T.bool.isRequired,

  onAddTask: T.func.isRequired,
  onClickVisibilityButton: T.func.isRequired,
  onClickOptionsButton: T.func.isRequired,
  onDownloadAllFiles: T.func.isRequired,

  placeholderName: T.string,
  placeholderDescription: T.string,
  descriptionNullMessage: T.string,
  iconShowTitle: T.string,
  iconHideTitle: T.string,
  iconOptionsTitle: T.string,
  downloadTitle: T.string,
  addTaskLabel: T.string,
};

MilestoneItemView.messages = [
  {code: 'tasks.misc.label', prop: 'placeholderName'},
  {code: 'tasks.misc.description', prop: 'placeholderDescription'},
  {code: 'milestones.properties.description.null.message', prop: 'descriptionNullMessage'},
  {code: 'icon.show.title', prop: 'iconShowTitle'},
  {code: 'icon.hide.title', prop: 'iconHideTitle'},
  {code: 'icon.options.title', prop: 'iconOptionsTitle'},
  {code: 'project.icon.download.title', prop: 'downloadTitle'},
  {code: 'project.button.create.task.label', prop: 'addTaskLabel'},
];

MilestoneItemView.messageProps = [
  'placeholderName',
  'placeholderDescription',
  'descriptionNullMessage',
  'iconShowTitle',
  'iconHideTitle',
  'iconOptionsTitle',
  'downloadTitle',
  'addTaskLabel',
];



// WEBPACK FOOTER //
// ./src/js/tasks/components/MilestoneItem/MilestoneItemView.js